<style lang="scss" scoped>

.list-enter-active,
.list-leave-active {
  transition: transform 1s;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
}

.logos {
    width: auto;
    max-width: 22%;
    max-height: 45px;
    margin-top: 3%;
    margin-right: 5%;
}

#sponsor-logo {
    width: auto;
    max-width: 100%;
    max-height: 41px;
    margin-top: 0.7rem;
    margin-bottom: 1rem; 
}


</style>

<template>
    <Content>
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <div class="page-pretitle">
                    Modul der Bewässerungs-App
                </div>
                <h2 class="page-title">
                    Bewässerungs-App Mobil
                </h2>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12">
                <ul>
                    <li class="mb-1">
                        Dokumentation von Wasserentnahmen
                    </li>
                    <li class="mb-1">
                        Dokumentation von Grundwasserstandsmessungen
                    </li>
                    <li class="mb-1">
                        Dokumentation der Bewässerung
                    </li>
                    <li class="mb-1">
                        Dokumentation von lokalen Niederschlägen
                    </li>
                    <li class="mb-1">
                        Einbindung und Dokumentation über lokale Sensorik
                    </li>
                    <li class="mb-0">
                        Eingliederung der dokumentierten Daten in die angelegten Schläge sowie Generierung von
                        Brunnentagebüchern unter
                        <a class="content-link" href="https://www.alb-bayern.de/app" target="_blank">www.alb-bayern.de/app</a>
                    </li>
                </ul>
            </div>
        </div>
        
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <div class="page-pretitle">
                    Verfügungsbefugnis
                </div>
                <h2 class="page-title">
                    Datenhoheit
                </h2>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12">
                Die ALB garantiert dem Nutzer der App die ausschließlichen Rechte an den von ihm erhobenen Daten. 
                Eine unwillentliche Weitergabe der Daten an Dritte ist ausgeschlossen. Eine mögliche Datenweitergabe
                kann nur durch aktives Handeln des Nutzers veranlasst werden.    
            </div>
        </div>
        
        <div class="row mt-4 mb-2">
            <div class="col-12">
                <div class="page-pretitle">
                    Partner
                </div>
                <h2 class="page-title">
                    Konzeption und Entwicklung
                </h2>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12 text-center">
                <img class="logos" style="max-width: 40%;" src="@/assets/logo.png" alt="">
                <img class="logos" style="max-height: 41px;" src="@/assets/lfu.png" alt="">
                <img class="logos" style="max-height: 35px;" src="@/assets/lwg.png" alt="">
                <img class="logos" src="@/assets/lfl.png" alt="">
				<img class="logos" src="@/assets/hswt.png" alt="">
            </div>
        </div>

        <div class="row mt-4 mb-2">
            <div class="col-12">
                <div class="page-pretitle">
                    Auftraggeber
                </div>
                <h2 class="page-title">
                    Finanzielle Förderung
                </h2>
            </div>
        </div>
        
        <div class="row mb-4">
            <div class="col-12 text-center">
                <img id="sponsor-logo" src="@/assets/logo-sponsor.png" alt="">
            </div>
        </div>
        
        
        <div v-if="false" class="row">
            <div class="col-12">
            
            
            <div class="accordion" id="accordion-example">
                  <div class="accordion-item bg-white">
                    <h2 class="accordion-header" id="heading-1">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="false">
                        Schläge und Schlagauswahl
                      </button>
                    </h2>
                    <div id="collapse-1" class="accordion-collapse collapse" data-bs-parent="#accordion-example" style="">
                      <div class="accordion-body pt-0">
                        Hier gibts Infos zu  <code>Schläge</code>. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi consectetur eros blandit, dictum purus ut, ultrices ipsum. Sed varius scelerisque turpis, vitae vehicula ex venenatis eget. Pellentesque vitae sodales leo. Praesent a faucibus lacus. Sed id sapien id tortor luctus molestie venenatis ut erat. Nullam in finibus ante. Proin quis lectus vel leo suscipit rutrum. Ut placerat purus et leo varius facilisis. Sed ultrices urna eu mi finibus iaculis blandit sed augue. Praesent hendrerit, massa eu suscipit tempor, nisi velit bibendum nulla, non feugiat erat nisl nec elit. 
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item bg-white">
                    <h2 class="accordion-header" id="heading-2">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="false">
                        Wasserentnahmestellen und Brunnen 
                      </button>
                    </h2>
                    <div id="collapse-2" class="accordion-collapse collapse" data-bs-parent="#accordion-example" style="">
                      <div class="accordion-body pt-0">
                        Hier gibts Infos zu  <code>Wasserentnahmestellen und Brunnen </code>. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi consectetur eros blandit, dictum purus ut, ultrices ipsum. Sed varius scelerisque turpis, vitae vehicula ex venenatis eget. Pellentesque vitae sodales leo. Praesent a faucibus lacus. Sed id sapien id tortor luctus molestie venenatis ut erat. Nullam in finibus ante. Proin quis lectus vel leo suscipit rutrum. Ut placerat purus et leo varius facilisis. Sed ultrices urna eu mi finibus iaculis blandit sed augue. Praesent hendrerit, massa eu suscipit tempor, nisi velit bibendum nulla, non feugiat erat nisl nec elit. 
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item bg-white">
                    <h2 class="accordion-header" id="heading-3">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-3" aria-expanded="false">
                        Niederschläge und Korrekturen
                      </button>
                    </h2>
                    <div id="collapse-3" class="accordion-collapse collapse" data-bs-parent="#accordion-example" style="">
                      <div class="accordion-body pt-0">
                        Hier gibts Infos zu  <code>Schläge</code>. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi consectetur eros blandit, dictum purus ut, ultrices ipsum. Sed varius scelerisque turpis, vitae vehicula ex venenatis eget. Pellentesque vitae sodales leo. Praesent a faucibus lacus. Sed id sapien id tortor luctus molestie venenatis ut erat. Nullam in finibus ante. Proin quis lectus vel leo suscipit rutrum. Ut placerat purus et leo varius facilisis. Sed ultrices urna eu mi finibus iaculis blandit sed augue. Praesent hendrerit, massa eu suscipit tempor, nisi velit bibendum nulla, non feugiat erat nisl nec elit. 
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item bg-white">
                    <h2 class="accordion-header" id="heading-4">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-4" aria-expanded="false">
                         Bewässerungsmaßnahmen 
                      </button>
                    </h2>
                    <div id="collapse-4" class="accordion-collapse collapse" data-bs-parent="#accordion-example" style="">
                      <div class="accordion-body pt-0">
                        Hier gibts Infos zu  <code>Schläge</code>. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi consectetur eros blandit, dictum purus ut, ultrices ipsum. Sed varius scelerisque turpis, vitae vehicula ex venenatis eget. Pellentesque vitae sodales leo. Praesent a faucibus lacus. Sed id sapien id tortor luctus molestie venenatis ut erat. Nullam in finibus ante. Proin quis lectus vel leo suscipit rutrum. Ut placerat purus et leo varius facilisis. Sed ultrices urna eu mi finibus iaculis blandit sed augue. Praesent hendrerit, massa eu suscipit tempor, nisi velit bibendum nulla, non feugiat erat nisl nec elit. 
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </Content>
</template>

<script>

import Content from '@/components/Content.vue';

export
default {
    name: 'About',
    components: {
        Content
    },
    inject: [
        'state',
        'config'
    ],
    data: function () {
        return {
            
        }
    },
    computed: {
      
    },
    methods: {
      
    },
    watch: {

    }
}


</script>
